import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m18 16 1 1.5v-5l-3-6c-.145-.315-.534-.448-.871-.492L15 6H7c-.5 0-1 .5-1 .5l-.5 1c-.636-.215-2.129-.323-2.129-.323l.546-1.325A3 3 0 0 1 6.5 4h9A3 3 0 0 1 18 5.667l.083.185L19 8l1.248-.832A1 1 0 0 1 20.803 7H22v2h-1l-1.021 1.021L21 12.5V20h-2.5L17 18h-2.153a13 13 0 0 0-.474-2zm-5.004 3.712C12.843 13.77 7.98 9 2 9v2l.265.004A9 9 0 0 1 11 20h2zM2 13a7 7 0 0 1 6.996 6.76L9 20H7a5 5 0 0 0-4.783-4.995L2 15zm0 4a3 3 0 0 1 2.995 2.824L5 20H2zm14.5-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      fill={color}
    />
  </svg>
);
